<script lang="ts" setup>
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/vue'
import { mainMenu } from '@/Support/Menus/mainMenu'
import { Link as InertiaLink, router } from '@inertiajs/vue3'
import { MenuItem } from '@/Support/Menus/Interfaces/MenuItem'
import AppIcon from '@/Components/App/Global/AppIcon.vue'

const navigate = (item: MenuItem, close: unknown) => {
  close()
  if (item.external) {
    window.open(item.url, '_blank')
  } else {
    router.get(item.url)
  }
}
</script>

<template>
  <div class="hidden lg:block lg:col-span-2">
    <nav class="flex space-x-4">
      <Popover
        v-for="item in mainMenu"
        :key="item.name"
        v-slot="{ open }"
        class="relative"
      >
        <!--                    :class="[open ? 'text-neutral-900' : 'text-neutral-500', 'group bg-white rounded-md inline-flex items-center text-base font-medium hover:text-neutral-900 focus:outline-hidden focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500']"-->
        <PopoverButton
          :aria-current="item.current ? 'page' : undefined"
          :class="[
            item.current ? 'text-white' : 'text-neutral-100',
            'text-sm font-medium rounded-md bg-white/0 px-3 py-2 hover:bg-white/10 outline-0',
          ]"
        >
          <span v-if="item.content">{{ item.name }}</span>
          <inertia-link v-else :href="route(item.route)">
            {{ item.name }}
          </inertia-link>
          <!--                    <ChevronDownIcon-->
          <!--                      :class="[open ? 'text-neutral-600' : 'text-neutral-400', 'ml-2 h-5 w-5 group-hover:text-neutral-500']" aria-hidden="true"-->
          <!--                    />-->
        </PopoverButton>

        <transition
          enter-active-class="transition ease-out duration-200"
          enter-from-class="opacity-0 translate-y-1"
          enter-to-class="opacity-100 translate-y-0"
          leave-active-class="transition ease-in duration-150"
          leave-from-class="opacity-100 translate-y-0"
          leave-to-class="opacity-0 translate-y-1"
        >
          <PopoverPanel
            v-if="item.content"
            v-slot="{ close }"
            class="absolute z-20 mt-3 px-2 w-screen sm:px-0 -ml-6"
            :class="{
              'lg:max-w-3xl': item.double,
              'max-w-md': !item.double,
            }"
          >
            <div
              class="rounded-3xl shadow-lg/20 dark:shadow-lg/30 ring-1 ring-black/5 overflow-hidden"
            >
              <div
                class="relative grid backdrop-blur-xs bg-white/85 dark:bg-neutral-950/70 px-5 py-6 sm:p-8"
                :class="{
                  'grid-cols-1 gap-x-6 gap-12 lg:grid-cols-2': item.double,
                  'gap-6 sm:gap-8': !item.double,
                }"
              >
                <PopoverButton
                  v-for="subItem in item.content"
                  :key="subItem.name"
                  as="a"
                  class="group cursor-pointer -m-3 p-3 flex items-start rounded-lg hover:bg-neutral-50 dark:hover:bg-neutral-700 transition ease-in-out duration-150"
                  @click="navigate(subItem, close)"
                >
                  <div
                    class="bg-neutral-100 dark:bg-neutral-800 border-0 rounded-sm p-2 group-hover:shadow-sm min-w-10 h-10 flex justify-center items-center"
                  >
                    <AppIcon
                      :icon="subItem.icon"
                      solid
                      class="text-neutral-400 group-hover:text-neutral-600 dark:text-neutral-300 size-6"
                    />
                  </div>
                  <div class="ml-4">
                    <p
                      class="text-base font-medium text-neutral-900 dark:text-neutral-200 group-hover:text-neutral-950 dark:group-hover:text-neutral-100"
                    >
                      {{ subItem.name }}
                    </p>
                    <p
                      class="mt-1 text-sm text-neutral-500 group-hover:text-neutral-700 dark:text-neutral-400 dark:group-hover:text-neutral-300"
                    >
                      {{ subItem.description }}
                    </p>
                  </div>
                </PopoverButton>
              </div>
              <div
                v-if="item.description"
                class="px-5 py-5 backdrop-blur-xs bg-neutral-200/50 dark:bg-neutral-800/50 space-y-6 sm:flex sm:space-y-0 sm:space-x-10 sm:px-8"
              >
                <span class="text-xs text-neutral-700 dark:text-neutral-300">
                  {{ item.description }}
                </span>
              </div>
            </div>
          </PopoverPanel>
        </transition>
      </Popover>
    </nav>
  </div>
</template>
